import type { Lang } from './i18n';

/** Words for a mouse and keys, and the same for a finger (forTouch), longest first. */
const TOUCH_WORDS: Record<Lang, [RegExp, string][]> = {
  tr: [
    [/\s\((?:[A-Z]|\d|F\d+|Boşluk)\)/g, ''],
    [/\bR (ile|binayı)\b/g, '↻ $1'],
    [/tıklayınca/g, 'dokununca'],
    [/tıklarsan/g, 'dokunursan'],
    [/tıklamak/g, 'dokunmak'],
    [/tıklayıp/g, 'dokunup'],
    [/tıklayarak/g, 'dokunarak'],
    [/tıkla/g, 'dokun'],
    [/Tıkla/g, 'Dokun'],
  ],
  en: [
    [/\s\((?:[A-Z]|\d|F\d+|Space)\)/g, ''],
    [/\bR (rotates|turns)\b/g, '↻ $1'],
    [/clicking/g, 'tapping'],
    [/clicked/g, 'tapped'],
    [/click/g, 'tap'],
    [/Click/g, 'Tap'],
  ],
  // The translations say "click" with these verbs (щёлкнуть, cliquer, klicken).
  ru: [
    [/\s\((?:[A-Z]|\d|F\d+|Пробел)\)/g, ''],
    [/щёлкнув/g, 'коснувшись'],
    [/щелчком/g, 'касанием'],
    [/щелчок/g, 'касание'],
    [/щёлкнуть/g, 'коснуться'],
    [/щёлкните/g, 'коснитесь'],
    [/Щёлкните/g, 'Коснитесь'],
  ],
  fr: [
    [/\s\((?:[A-Z]|\d|F\d+|Espace)\)/g, ''],
    [/en cliquant/g, 'en touchant'],
    [/cliquez/g, 'touchez'],
    [/Cliquez/g, 'Touchez'],
    [/cliquer/g, 'toucher'],
  ],
  de: [
    [/\s\((?:[A-Z]|\d|F\d+|Leertaste)\)/g, ''],
    [/angeklickt/g, 'angetippt'],
    [/anklicken/g, 'antippen'],
    [/Klicke/g, 'Tippe'],
    [/klicke/g, 'tippe'],
    [/klicken/g, 'tippen'],
    [/Klick/g, 'Tipp'],
  ],
};

/**
 * A text written for a mouse and keyboard, said for a finger: no key numbers, "tap" for
 * "click", the turn button for R (lessons and goals on a touch screen).
 */
export function forTouch(text: string, lang: Lang): string {
  let out = text;
  for (const [from, to] of TOUCH_WORDS[lang]) out = out.replace(from, to);
  return out;
}
